<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>Adicionar Função à Convenção</h2>
      </v-card-title>

      <v-card-text>
        <v-text-field label="Função" v-model="occupationSelected" disabled></v-text-field>

        <v-text-field label="Salário Base (R$)" v-model="item.basicSalary" autofocus></v-text-field>

        <label>Adicionar gratificação</label>

        <v-tooltip bottom>
          <v-btn outline small fab color="teal" slot="activator">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Adicionar gratificação</span>
        </v-tooltip>
      </v-card-text>

      <span class="blue--text pa-3">Os campos marcados com o (*) são obrigatórios</span><br><br>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark @click="cancel();">Cancelar</v-btn>
        <v-btn color="blue darken-1" dark @click="save();">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// SERVICES //
import CollectiveConventionService from "../../service/CollectiveConventionService.js";

export default {
  props: {
    yearConventionSelected: {},
    occupationSelected: ""
  },

  data: () => ({
    convention: {},
    item: {},
    occupations: []
  }), //data()

  methods: {
    async init() {
      this.item = {};
    }, //init()

    async changeOccupations() {
      try {
        this.occupations = [];
      } catch (error) {}
      this.setConvention();
    }, //changeOccupations()

    setConvention() {
      this.convention = this.yearConventionSelected;
    }, //setConvention()

    setObject() {
      this.item.occupation = this.occupationSelected;
    }, //setObject()

    async save() {
      this.setObject();
      this.convention.items.push(this.item);
      try {
        CollectiveConventionService.edit(this.convention);
      } catch (error) {}

      this.cancel();
    }, //save()

    cancel() {
      this.$eventHub.$emit("cancelDialogSetConventionItem");
    } //cancel()
  }, //methods

  async created() {
    this.init();

    this.$eventHub.$on("savedNewOccupation", _ => {
      this.changeOccupations();
    });
  } //created
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/FormSetConventionItem.vue